import { CATALOG_ITEM_ADDITIONAL_PARAMETERS_SEQUENCE } from '@common/model/catalog/item/additionalParameters';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import React from 'react';

export const useHasAdditionalParameters = (data: CatalogItemViewModel | undefined): boolean => {
  return React.useMemo(() => {
    if (!data) {
      return false;
    }
    return Boolean(CATALOG_ITEM_ADDITIONAL_PARAMETERS_SEQUENCE.filter((key) => Boolean(data[key])).length);
  }, [data]);
};
